import request from "@/utils/request";

// 创建美育浸润
export const createMyjr = (data) => {
    return request({
        url: "/businessservice/myjr/create",
        method: "post",
        data: data
    })
}

// 创建美育浸润
export const updateMyjr = (data) => {
    return request({
        url: "/businessservice/myjr/update",
        method: "post",
        data: data
    })
}

// 创建美育浸润
export const pageMyjr = (data) => {
    return request({
        url: "/businessservice/myjr/page",
        method: "post",
        data: data
    })
}

// 查询美育浸润信息
export const  infoMyjr =(query) =>{
    return request({
        url: "/businessservice/myjr/info",
        method:"get",
        params: query
    })
}

// 删除美育浸润信息
export const  deleteMyjr =(query) =>{
    return request({
        url: "/businessservice/myjr/delete",
        method:"get",
        params: query
    })
}

